// extracted by mini-css-extract-plugin
module.exports = {"helpText":"TotpUserResetPasswordHandler__helpText"};